
export enum EnumSystemOptions 
{
    IsSupportedPasswordChange = "IsSupportedPasswordChange",
    IsSupportedPasswordRecovery = "IsSupportedPasswordRecovery",
    IsSupportedLoginByOTP = "IsSupportedLoginByOTP",
    IsSupportedLoginByPassword = 'IsSupportedLoginByPassword',
    IsRequireTaxNumberForOTP = 'IsRequireTaxNumberForOTP',
    ShowExpiredTimeoutAlert = 'ShowExpiredTimeoutAlert',
    ShowAlmostExpiredTimeoutAlert = 'ShowAlmostExpiredTimeoutAlert',
    SessionTimeout = 'SessionTimeout',
    PasswordComplexityLen = "PasswordComplexityLen",
    PasswordComplexityMinChars = "PasswordComplexityMinChars",
    PasswordComplexityMinDigits = "PasswordComplexityMinDigits",
    VatValue = "VatValue"
}
